import { useLanguageCodeMasterSelector } from "../redux/selector";

const useBuildNavLink = () => {
  const languageCode = useLanguageCodeMasterSelector();
  return function buildNavLink(baseLink: string) {
    return languageCode ? `/${languageCode}${baseLink}` : baseLink;
  };
};

export default useBuildNavLink;
